/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Te_Summary_Steady_AerobicInputs */

const en_ui_te_summary_steady_aerobic = /** @type {(inputs: Ui_Te_Summary_Steady_AerobicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Steady aerobic session with minimal anaerobic demand.`)
};

const de_ui_te_summary_steady_aerobic = /** @type {(inputs: Ui_Te_Summary_Steady_AerobicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gleichmäßig aerob, kaum anaerobe Belastung.`)
};

/**
* | output |
* | --- |
* | "Steady aerobic session with minimal anaerobic demand." |
*
* @param {Ui_Te_Summary_Steady_AerobicInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_te_summary_steady_aerobic = /** @type {((inputs?: Ui_Te_Summary_Steady_AerobicInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Te_Summary_Steady_AerobicInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_te_summary_steady_aerobic(inputs)
	return de_ui_te_summary_steady_aerobic(inputs)
});